export const COMPONENT_NAME = 'Footer';
